import styled from "styled-components";
import { ButtonContained, ButtonText, FontStyles } from "../../../components";
import { Spacing } from "../../../config";

const Container = styled.div(({ theme, $dark, $row }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: $dark ? theme.palette.action.selected : theme.palette.background.paper,

    borderRadius: "5px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});

const ContainerSecondary = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    backgroundColor: theme.palette.action.selected,
    padding: "16px 20px",
    borderRadius: "10px",

    width: "100%",
    // margin: "20px",
    height: "fit-content",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "8px",
    },
  };
});
const ButtonContainer = styled.div(({ theme }) => {
  return {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row",
    gap: theme.spacing(1),
  };
});
const Submit = styled(ButtonContained)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      backgroundColor: theme.palette.action.selected,
      ...FontStyles.semibold12,
      paddingInline: theme.spacing(2.5),
      paddingBlock: theme.spacing(1.9),
    },
  };
});
const Clear = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      color: theme.palette.action.selected,
      ...FontStyles.semibold12,
      paddingInline: theme.spacing(2.5),
      paddingBlock: theme.spacing(1.9),
    },
  };
});
const OnUse = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    paddingInline: theme.spacing(1.625),
    paddingBlock: theme.spacing(1),
    backgroundColor: "#4D585A",
    color: "white",
    borderRadius: theme.spacing(2),
    margin: 0,
  };
});

const RegitryContainer = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  };
});

const RegitryButton = styled(ButtonContained)(({ theme, alternative }) => {
  const bg = alternative ? "#fff" : "#0C396D";
  const txtColor = alternative ? "#24272A" : "#FFFFFF";
  return {
    "&&.MuiButton-root": {
      background: bg,
      color: txtColor,
      borderRadius: 21,
      marginTop: 0,
      transition: "none",
      "&:hover": {
        background: bg,
        boxShadow: "none",
      },
      "&:focus, &:active": {
        background: bg,
        boxShadow: "none",
      },
      ...FontStyles.medium14,

      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});

const CancelButton = styled(ButtonText)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      marginTop: 0,
      ...FontStyles.medium14,
      color: "white",
      paddingInline: spacing(2),
      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});
const ViewButton = styled(ButtonContained)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      backgroundColor: "#4D585A",
      color: colors.text.secondary,
      paddingBlock: "6px",
      paddingInline: "13px",
      marginTop: 0,
      ...FontStyles.medium12,

      "&:hover": {
        backgroundColor: colors.text.primary,
      },

      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});

const Label = styled.p(({ theme, $withError, $color, white }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.semibold14,
    textTransform: "uppercase",
    padding: 0,
    margin: 0,
    color: "white",
    transition: ".2s",
    pointerEvents: "none",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
    paddingTop: spacing(2.5),
  };
});
const Value = styled.p(({ theme, $withError, $color, white }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.medium14,
    paddingBlock: spacing(1.25),
    color: "white",
    width: "100%",
    borderBottom: "1px solid #fff",
    margin: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    wordBreak: "break-all",
  };
});

const ContainerFilter = styled.div(({ theme, noLine }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    padding: "16px 20px",
    paddingInline: noLine && 0,
    borderRadius: "5px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});
const ValueSpan = styled.span(({ theme, $disabled }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.medium12,

    color: "white",

    margin: 0,
    cursor: "pointer",
    textDecoration: "underline",
    display: "flex",
    gap: "4px",
    alignItems: "center",
    opacity: $disabled && 0.33,
  };
});
const Styles = {
  Container,
  Submit,
  Clear,
  ButtonContainer,
  ContainerFilter,
  OnUse,
  RegitryContainer,
  RegitryButton,
  ContainerSecondary,
  CancelButton,
  ViewButton,
  Label,
  Value,
  ValueSpan,
};

export default Styles;
